import { connect } from 'react-redux'
import TableOfContentsItem from './TableOfContentsItem.jsx'
import { jumpToMediaGroup } from 'redux/navigation/actions'

const mapDispatchToProps = (dispatch, {positions, mediaId}) => ({
    onClick: () => dispatch(jumpToMediaGroup(positions, mediaId))
})

export const TableOfContentsItemContainer = connect(
    undefined,
    mapDispatchToProps,
)(TableOfContentsItem)
